import type { Resource } from '../../';
export const product_details_addedToCart: Resource = {"default":"{productName} has been added to your bag!"};
